import type { VenueData } from './types';

interface VenueHeaderProps {
  venue: VenueData;
}

export const VenueHeader = ({ venue }: VenueHeaderProps) => {
  return (
    <div className="border-b border-gray-200 pb-6">
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
        <div>
          <h1 className="text-3xl sm:text-4xl mb-2">
            {venue.name}
          </h1>
          <p className="text-sm text-gray-500 mt-1">
            {venue.address.city}, {venue.address.state}
          </p>
          <h2 className="mt-4">Venue Management Dashboard</h2>

        </div>
        
        {/* Status indicator for mobile responsiveness */}
        <div className="flex-shrink-0">
          <div className="inline-flex items-center px-3 py-1 rounded-full text-sm font-medium bg-primary-50 text-primary-800 border border-primary-200">
            <div className="w-2 h-2 bg-primary-700 rounded-full mr-2" aria-hidden="true"></div>
            Active
          </div>
        </div>
      </div>
    </div>
  );
};